<script setup>
import ModalWrapper from '@/modals/ModalWrapper';
import { ref } from 'vue';
import { useKaleidicalStore } from '@/stores/kaleidical';

const emit = defineEmits(['close-modal']);

const code = ref('');

const { accept } = useKaleidicalStore();

const save = async () => {
    await accept({
        code: code.value,
    });

    emit('close-modal');

};
</script>

<template>
<ModalWrapper>
    <template #header>Enter Code</template>

    <form @submit.prevent="save">
        <p class="mb-3">Please Enter Your 6 Digit Invite Code</p>
        <vOtpInput
            v-model="code"
            name="code"
            variant="solo"
            autocomplete="off" />
    </form>

    <template #footer>
        <StyledSaveButton modal @save="save" />
    </template>
</ModalWrapper>
</template>
